module.exports = __webpack_public_path__ + "assets/img/sci_map.cef2cce8.png";